import buttonStyles from '../../styles/UI/Button.module.css';

export const StandardButton = ({
	onClick,
	title,
	noBax,
	icon,
	classes,
	disable
}: {
	onClick: () => void;
	title: string;
	noBax?: boolean;
	icon?: React.ReactNode;
	classes?: string;
	disable?: boolean;
}) => {
	const classList = `${buttonStyles.standardButton} ${classes ? classes : null}`;
	return (
		<>
			{noBax ? (
				<div className="mr-[1rem] no-bax-label">
					{icon}
					{title}
				</div>
			) : (
				<button onClick={onClick} className={classList} disabled={disable}>
					{icon}
					{title}
				</button>
			)}
		</>
	);
};
